import { useAddToBookmarks } from './useAddToBookmarks';
import { useAlerts } from './useAlerts';
import { useGlobalStyles } from './useGlobalStyles';
import { useSubscribeToCsatSurveys } from './useSubscribeToCsatSurveys';
import { useSubscribeToWootricSurveys } from './useSubscribeToWootricSurveys';
export const useNavigationCapabilities = () => {
  useAddToBookmarks();
  useGlobalStyles();
  useSubscribeToCsatSurveys();
  useSubscribeToWootricSurveys();
  useAlerts();
};